import React, { useState } from "react";
import { DatePicker, Space, Select, Input } from "antd";

const ReferralAccountFilter = ({
  filters,
  onFiltersChange,
  defaultField,
  tabName,
}) => {
  const [searchField, setSearchField] = useState(defaultField || "email");

  const searchBy = (
    <Select
      defaultValue="email"
      className="select-before"
      onChange={(value) => setSearchField(value)}
    >
      <Select.Option value="username">Name</Select.Option>
      <Select.Option value="email">Email</Select.Option>
    </Select>
  );

  const searchTransactionBy = (
    <Select
      defaultValue="userEmail"
      className="select-before"
      onChange={(value) => setSearchField(value)}
    >
      <Select.Option value="userEmail">Email</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      {tabName === "referral" ? (
        <div>
          Email Verified On :{` `}
          <DatePicker.RangePicker
            value={[filters.startDate, filters.endDate]}
            onChange={(dates) =>
              dates
                ? onFiltersChange({
                    ...filters,
                    startDate: dates[0],
                    endDate: dates[1],
                  })
                : onFiltersChange({
                    ...filters,
                    startDate: undefined,
                    endDate: undefined,
                  })
            }
          />
        </div>
      ) : (
        <div>
          Created At :{` `}
          <DatePicker.RangePicker
            picker="month"
            value={[filters.startDate, filters.endDate]}
            onChange={(dates) =>
              dates
                ? onFiltersChange({
                    ...filters,
                    startDate: dates[0],
                    endDate: dates[1],
                  })
                : onFiltersChange({
                    ...filters,
                    startDate: undefined,
                    endDate: undefined,
                  })
            }
          />
        </div>
      )}

      {tabName === "referral" ? (
        <div>
          Search :{` `}
          <Input.Search
            addonBefore={searchBy}
            placeholder="Search"
            onSearch={(term) =>
              onFiltersChange({ ...filters, search: term, searchField })
            }
          />
        </div>
      ) : (
        <div>
          Search :{` `}
          <Input.Search
            addonBefore={searchTransactionBy}
            placeholder="Search"
            onSearch={(term) =>
              onFiltersChange({ ...filters, search: term, searchField })
            }
          />
        </div>
      )}
    </Space>
  );
};

export default ReferralAccountFilter;
